import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { useTenderList } from '@/modules/Tenders/hooks/use-tender-list'
import { TenderListVariant } from './tender-list-config'

const TenderListView = ({ variant }: { variant: TenderListVariant }) => {
    const {
        tenders,
        pagination,
        stateComponent,
        params,
        searchInputProps,
        columns,
        actions,
        filterToggles,
        selectedKeys,
        setSelectedKeys,
        selectionActions,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useTenderList(variant)

    return (
        <Paper className="mt-2">
            {stateComponent || (
                <DataTableCustomized
                    columns={columns}
                    rows={tenders}
                    rowKey={(row) => row.id}
                    actions={actions}
                    size="small"
                    selection={{
                        selectedKeys,
                        onSelectionChange: setSelectedKeys,
                        getRowKey: (row) => String(row.id),
                        actions: selectionActions,
                    }}
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search_placeholder'),
                        },
                        settings: {
                            show: true,
                            storageKey: `tenders-${variant}`,
                            filterToggles,
                        },
                    }}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                />
            )}
        </Paper>
    )
}

export default TenderListView
